import { RouterProvider } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { TooltipProvider } from '@/components/ui/tooltip';

import { router } from '@/routes/router';
import { queryClient } from '@/services/api/queryClient';

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={150}>
        <RouterProvider router={router} />
        <Toaster
          position="top-right"
          richColors
          closeButton
          toastOptions={{
            // Estilo coherente con shadcn/ui
            style: { borderRadius: 'var(--radius)' },
          }}
        />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
